import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';

class QuickSearch extends Component {
    constructor(props) {
        super(props);
        
        this.state = { 
            focus: false, 
            showResults: false 
        };
        
        this.clickOutside = this.clickOutside.bind(this);
    }
    
    componentDidMount() {
        document.addEventListener('mousedown', this.clickOutside);
    }
    
    componentWillUnmount() {
        document.removeEventListener('mousedown', this.clickOutside);
    }

    eventTargetIsScrollbar(event){
        return event.target === document.getElementsByTagName("html")[0];
    }
    
    clickOutside(event){
        if(this.eventTargetIsScrollbar(event)){
            return
        }

        let element = document.querySelector('.quick-search');
        let clickedOutsideElement = !element.contains(event.target);
        
        if (clickedOutsideElement) {
            this.setState({ 
                focus: false, 
                showResults: false 
            });
        }
    }

    handleInputFocus(){
        this.setState({ 
            focus: true,
            showResults: true 
        });
        
        this.closeMegaMenuIfOpen();
    }
    
    closeMegaMenuIfOpen(){
        document.querySelectorAll('.dropdown-menu-megamenu').forEach(megaMenuContainer => {
            let shouldCloseMenu = !megaMenuContainer.contains(event.target) && megaMenuContainer.classList.contains("show");

            if (shouldCloseMenu) {
                let dropdownButton = megaMenuContainer.parentNode.querySelector('.dropdown-toggle');
                dropdownButton.classList.remove('show');
                dropdownButton.setAttribute('aria-expanded', 'false');
                
                megaMenuContainer.classList.remove('show');
                megaMenuContainer.setAttribute('aria-expanded', 'false');
            }
        });
    }
    
    render() {
        const { query, result, showResult, showFullForm, onSearch, onBlur, onKeyDown, toggleShowFullForm, selectedItem, searchUrl, onClose } = this.props;
        return (
            <div className={`quick-search d-flex align-items-center justify-content-between ${this.state.focus ? 'search-active' : ''}`} role="search">
                <div className={`quick-search__form d-flex align-items-center justify-content-between`} role="search">
                    <div className="dropdown w-100">
                        <input className="quick-search__input" type="search"
                            placeholder={translate('general.search')}
                            autoComplete="off" value={decodeURIComponent(query)} onChange={event => onSearch(encodeURIComponent(event.target.value))}
                            onKeyDown={event => onKeyDown(event, { searchUrl })} ref={(input) => { this.searchInput = input; }}
                            onBlur={() => {
                                onBlur();
                                this.setState({ focus: false });
                            }}
                            onFocus={() => this.handleInputFocus()}
                        />
                        {showResult && this.state.showResults && <QuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrl} onClose={onClose} />}
                    </div>
                    <button className="quick-search__submit-button" type="submit">
                        <i className="quick-search__submit-icon bi bi-search"></i>
                    </button>
                </div>
            </div>
        )
    }
}

export default QuickSearch;